import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-new-window-link',
  imports: [
    RouterLink
  ],
  templateUrl: './new-window-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewWindowLinkComponent {
  public readonly id = input.required<string>();
  public readonly base = input<string>('/users');
}
